// SupervisorDashboard tab IDs, region options, default filter values, route columns.
//
// NOTE: The LocationRoutes `market` field stores region codes (MW/NE/WC/S),
// and `fulfillmentCenter` stores city-level FC names like "Chicago".
// The UI labels Region (mapped to `market`) and Market (mapped to `fulfillmentCenter`)
// reflect the user-facing concepts, not the legacy field names.

export const TAB_IDS = {
  ROUTE_REVIEW: 'route-review',
  PLANNING: 'planning',
  DAY_BEFORE: 'day-before',
  DAY_OF: 'day-of',
  EXCEPTION_REVIEW: 'exception-review',
};

export const TABS = [
  { id: TAB_IDS.ROUTE_REVIEW, label: 'Route Review' },
  { id: TAB_IDS.PLANNING, label: 'Planning' },
  { id: TAB_IDS.DAY_BEFORE, label: 'Day Before' },
  { id: TAB_IDS.DAY_OF, label: 'Day Of' },
  { id: TAB_IDS.EXCEPTION_REVIEW, label: 'Exception Review' },
];

export const REGION_ALL = 'ALL';

export const REGIONS = [
  { value: REGION_ALL, label: 'All Regions' },
  { value: 'MW', label: 'MW' },
  { value: 'NE', label: 'NE' },
  { value: 'WC', label: 'WC' },
  { value: 'S', label: 'S' },
];

export const DATE_RANGE_LIMIT_DAYS = 31;
export const DEFAULT_DATE_RANGE_DAYS = 30;

export const ROUTE_COLUMNS = [
  { key: 'stockingDate', label: 'Stocking Date', sortable: true, width: 130 },
  { key: 'market', label: 'Region', sortable: true, width: 90 },
  { key: 'fulfillmentCenter', label: 'Market', sortable: true, width: 160 },
  { key: 'route', label: 'Route', sortable: true, width: 190 },
  { key: 'stop', label: 'Stop', sortable: true, width: 80 },
  { key: 'stockingIndex', label: 'Stocking Index', sortable: true, width: 120 },
  { key: 'stopType', label: 'Stop Type', sortable: true, width: 110 },
  {
    key: 'toteCountPerStop',
    label: 'Totes / Stop',
    sortable: true,
    width: 110,
  },
  {
    key: 'toteCountPerRoute',
    label: 'Totes / Route',
    sortable: true,
    width: 110,
  },
  { key: 'onlineDate', label: 'Online Date', sortable: true, width: 130 },
  {
    key: 'stockedTimeUTC',
    label: 'Stocked Time UTC',
    sortable: true,
    width: 180,
  },
];
